import { BillingManagementAccountType } from '@/redux/modules/billingManagement/billingManagement.types';
import { handleResponseV2, makePost } from '@/redux/api/helpers';
import { ReceivedPayment } from '@/redux/modules/billingManagement/receivedPayment/receivedPayment.types';

type PostReceivedPaymentParams = {
    authToken: string;
    deployment: string;
    houseId: number;
    receivedPayment: ReceivedPayment;
};

export type PostReceivedPaymentResponsePayload = ReceivedPayment & {
    accountType: BillingManagementAccountType;
    /**
     * Should be the negative value of `amount`
     */
    billingItemsAmount: number;
    createdByUsername: string;
    glCode: number;
    paymentName: string;
};

export type PostReceivedPaymentResponse = {
    error: boolean;
    payload: PostReceivedPaymentResponsePayload;
};

export const postReceivedPayment = ({ authToken, deployment, houseId, receivedPayment }: PostReceivedPaymentParams) =>
    new Promise<PostReceivedPaymentResponse>((resolve, reject) => {
        const request = makePost({
            apiPath: `admin/house/${houseId}/billing/received-payment`,
            authToken,
            deployment,
            path: '<PAYMENT-SERVER-API>',
        });
        request.send(receivedPayment);
        request.end((err, response) =>
            handleResponseV2({
                err,
                reject,
                resolve,
                response,
            })
        );
    });
